import { useQuery } from "@tanstack/react-query";
import { fetchTree } from "@/notes/api/notes";

export const useTree = () => {
	return useQuery({
		queryKey: ["tree"],
		queryFn: fetchTree,
	});
};
